import { Box, Grid2, Skeleton, Stack } from "@mui/material";
import React from "react";
import { zoullooColors } from "../../../theme";
import FreelancerDetailsSkeleton from "../../../components/common/components/freelancerDetails/FreelancerDetailsSkeleton";

const ApplicationDetailsSkeleton: React.FC = () => {
	return (
		<Box px={{ xs: 2, sm: 4, md: 4 }} py={3}>
			<Grid2 container spacing={3}>
				{/* Left Side - Freelancer Details Skeleton */}
				<Grid2 size={{ xs: 12, lg: 9 }}>
					<FreelancerDetailsSkeleton />
				</Grid2>

				{/* Right Side - Application Info Skeleton */}
				<Grid2 size={{ xs: 12, lg: 3 }}>
					<Box
						sx={{
							position: "sticky",
							top: 24,
							alignSelf: "flex-start"
						}}
					>
						<Box
							sx={{
								border: `1px solid ${zoullooColors.grey[300]}`,
								borderRadius: "20px",
								overflow: "hidden"
							}}
						>
							{/* Accordion Header */}
							<Box
								sx={{
									backgroundColor: zoullooColors.grey[100],
									p: 2,
									borderBottom: `1px solid ${zoullooColors.grey[300]}`
								}}
							>
								<Skeleton variant="text" width="60%" height={28} />
							</Box>

							{/* Accordion Content */}
							<Box sx={{ backgroundColor: zoullooColors.background.default }}>
								<Stack spacing={0}>
									{Array.from({ length: 7 }, (_, index) => `skeleton-row-${index}`).map(
										(uniqueKey, index) => (
											<Box
												key={uniqueKey}
												sx={{
													display: "flex",
													justifyContent: "space-between",
													p: 2,
													...(index < 6
														? { borderBottom: `1px solid ${zoullooColors.grey[300]}` }
														: {})
												}}
											>
												<Skeleton variant="text" width="50%" height={20} />
												<Skeleton variant="text" width="40%" height={20} />
											</Box>
										)
									)}
								</Stack>
							</Box>
						</Box>
					</Box>
				</Grid2>
			</Grid2>
		</Box>
	);
};

export default ApplicationDetailsSkeleton;
